import {
  editImageCommonStyle,
} from '@bingads-webui-campaign-react/common-styles';

import { getMMAPreviewStyles } from '@bingads-webui-campaign-react/shared-image-preview-styles';

import { panelStyle, previewHeaderStyle, previewContentStyle } from './preview-carousel-base-style';

export const getGridPreviewCarouselStyle = () => ({
  gridPreviewContainer: {
    ...editImageCommonStyle(),
    ...getMMAPreviewStyles(),

    ...panelStyle,
    '& .placements-grid-preview-cell': {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      ...previewHeaderStyle,
      ...previewContentStyle,
      '& .action-label': {
        textAlign: 'center',
        fontSize: 16,
        lineHeight: 2,
      },
    },
  },
});
